import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFolderLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 5C2 3.89543 2.89543 3 4 3H9.51938C10.1269 3 10.7016 3.27618 11.0811 3.75061L12.4806 5.5H20C21.1046 5.5 22 6.39543 22 7.5V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V5ZM9.51938 5H4V19H20V7.5H12.4806C11.8731 7.5 11.2984 7.22382 10.9189 6.74939L9.51938 5Z",
		fill: "currentColor"
	})
});
export default SvgFolderLine;
